import { all } from 'redux-saga/effects';

import fetchChangelog from './fetchChangelog';

export default function* () {
    yield all([fetchChangelog()]);
}
